/**
 * Card específica para el feed de historias completados del mes.
 * Solo visual: imagen como mosaico cuadrado/rectangular + título debajo (fuera del recuadro).
 * Desacoplada de LearningCard para no contaminar otras vistas.
 */

import styles from './CompletedStoryCard.module.scss';

export interface CompletedStoryCardProps {
  title: string;
  backgroundImage: string | null;
  onClick?: () => void;
}

export function CompletedStoryCard({ title, backgroundImage, onClick }: CompletedStoryCardProps) {
  return (
    <button type="button" className={styles.card} onClick={onClick} data-no-press-scale>
      <div
        className={styles.card__image}
        style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined}
        aria-hidden="true"
      />
      <h3 className={styles.card__title}>{title}</h3>
    </button>
  );
}

export default CompletedStoryCard;
